import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"รายงานตัว 90 วัน (TM.47) — ยื่นออนไลน์ ไปรษณีย์ หรือให้ทีม NYC ยื่นแทน","metaTitle":"รายงานตัว 90 วัน TM.47 Thailand — ยื่นแทน ออนไลน์ ประจำปี | NYC","metaDesc":"บริการยื่นรายงานตัว 90 วัน (TM.47) แทนชาวต่างชาติที่ถือ Non-B, Non-O, Non-Ed, LTR รวมทั้งคีย์ระบบออนไลน์ให้ในกรณี — ปรึกษาฟรี ประเมินงานให้ทันที ทักไลน์ได้เลย"},"en":{"h1":"90-Day Report (TM.47) — Online, Post or NYC Walk-in Service","metaTitle":"Thailand 90-Day Report TM.47 — Filing Service | NYC","metaDesc":"TM.47 90-day report filing for foreigners on Non-B, Non-O, Non-Ed and LTR visas. Online, EMS or walk- — Talk to a specialist today; no obligation, fast reply."}} as const;

export const Route = createFileRoute("/immigration/90-day")({
  head: () => {
    const url = `${SEO_SITE}/immigration/90-day`;
    const c = meta.th;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/immigration/90-day", "th")},
        { name: "description", content: ctaDesc(c.metaDesc, "/immigration/90-day", "th")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/immigration/90-day", "th")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/immigration/90-day", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/immigration/90-day", "/en/immigration/90-day")],
    };
  },
  component: () => <SubServicePage slug="immigration/90-day" locale="th" />,
});
